import { createMainAppMicroserviceInstance } from '@servicetitan/cp-api';
import { inject, injectable, optional } from '@servicetitan/react-ioc';
import { Scheduler, DynamicScheduler } from './schedulers.api';

@injectable()
export class SchedulerApi {
    private api: Scheduler;

    constructor(@inject('baseUrl') @optional() baseUrl?: string) {
        this.api = new Scheduler(
            createMainAppMicroserviceInstance('/v1/customerportal/scheduler', '/api/cp/scheduler'),
            baseUrl
        );
    }

    getScheduler(): Promise<DynamicScheduler> {
        return this.api.getDynamicScheduler(window.location.hostname).then(({ data }) => data);
    }
}
